export enum StorageProvider {
  Internal = 0,
  AWS = 1,
  Azure = 2,
}
